<div class="flex flex-col gap-6">
  <div class="rounded-2xl bg-[white] p-[20px] shadow-[0px_0px_10.6px_0px_rgba(0,0,0,0.15)]">
    <app-add-user-form />
  </div>
</div>
